import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';
import { useToast } from '../../context/ToastContext';
import { AuthContext } from '../../context/AuthContext';
import { Mail, Lock, Eye, EyeOff,ShieldCheck} from 'lucide-react';

export default function Login({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isOtpStep, setIsOtpStep] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [verifying, setVerifying] = useState(false);

  const navigate = useNavigate();
  const { showToast } = useToast();
  
  const { login } = useContext(AuthContext);

  const handleEmail = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputEmail) {
      setErrEmail("Vui lòng nhập email");
    } else if (!emailRegex.test(inputEmail)) {
      setErrEmail("Email không đúng định dạng!");
    } else {
      setErrEmail("");
    }
  };

  const handlePassword = (e) => {
    const inputPassword = e.target.value;
    setPassword(inputPassword);
    const passRegex =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!inputPassword) {
      setErrPassword("Vui lòng nhập mật khẩu");
    }else if(!passRegex.test(inputPassword)){
      setErrPassword("Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt")
    } else {
      setErrPassword("");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    let isValid = true;

    if (!email) {
      setErrEmail("Vui lòng nhập email");
      isValid = false;
    }
    if (!password) {
      setErrPassword("Vui lòng nhập mật khẩu");
      isValid = false;
    }

    if (isValid && !errEmail && !errPassword) {
      setLoading(true);
      try {
        const response = await axios.post(
          "https://japanichiba.duckdns.org/api/v1/auth/login",
          { email, password }
        );

        // Kiểm tra nếu response trả về dạng success: false
        if (response.data && response.data.success === false) {
          showToast(response.data.message || "Sai email hoặc mật khẩu!", "error");
          return;
        }

        const resBody = response.data;
        const userData = resBody.data || resBody;
        const roleStr = String(userData.role || "").toUpperCase();
        const isAdminAccount = roleStr === "ADMIN" || Number(userData.id) === 1 || email.toLowerCase().includes("admin");
        if (!isAdminAccount && !resBody.accessToken &&  userData.isActive === false ) {
          setIsOtpStep(true);
          showToast(resBody.message || "Tài khoản chưa được kích hoạt. Vui lòng nhập mã OTP!", "info");
          return; 
        }

        const token = userData.accessToken || userData.token || resBody.token;
        if (login) {
          login(userData, token);
        } else {
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem("token",token);
        }

        showToast(resBody.message || "Đăng nhập thành công! 🎉", "success");

        // Gọi callback để đóng modal ở component cha (AuthModal) nếu có
        if (onSuccess) onSuccess(userData);

        setTimeout(() => {
          const roleStr = String(userData.role || "").toUpperCase();
          const roleId = Number(userData.id);
          if (roleStr === "ADMIN" || roleId === 1) {
            navigate("/admin");
          } else {
            navigate("/");
          }
        }, 1000);

      } catch (error) {
        console.error("Lỗi đăng nhập chi tiết:", error);
        
        const errorMsg =
          error.response?.data?.message || 
          error.response?.data?.error || 
          error.message || 
          "Sai tài khoản hoặc mật khẩu!";
          
        showToast(errorMsg, "error");
      } finally {
        setLoading(false);
      }
    }
  };
 const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otpCode || otpCode.length < 6) {
      showToast("Vui lòng nhập đủ 6 chữ số mã OTP!", "error");
      return;
    }

    setVerifying(true);
    try {
      const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/verify-otp", {
        email: email,
        otp: otpCode
      });

      const resBody = response.data;
      const userData = resBody.data || resBody;
      const token = resBody.accessToken || userData.accessToken;

      // Lưu token vào Context hoặc LocalStorage
      if (login) {
        login(userData, token);
      } else {
        if (token) localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userData));
      }

      showToast(resBody.message || "Kích hoạt tài khoản thành công! 🎉", "success");

      if (onSuccess) onSuccess(userData);

      // Điều hướng ngay lập tức vào trang chủ hoặc admin
      setTimeout(() => {
        const roleStr = String(userData.role || "").toUpperCase();
        const roleId = Number(userData.id);
        if (roleStr === "ADMIN" || roleId === 1) {
          navigate("/admin");
        } else {
          navigate("/");
        }
      }, 1000);

    } catch (error) {
      console.error("Lỗi xác thực OTP:", error);
      showToast(error.response?.data?.message || "Mã OTP không chính xác hoặc đã hết hạn!", "error");
    } finally {
      setVerifying(false);
    }
  };
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const googleToken = credentialResponse.credential;
      
      // Gọi API Backend Java để xử lý token Google (ví dụ đường dẫn /api/v1/auth/google)
      const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/google", {
        token: googleToken
      });

      const resBody = response.data;
      const userData = resBody.data || resBody;
      const token = userData.accessToken || userData.token || resBody.token;

      if (login) {
        login(userData, token);
      } else {
        localStorage.setItem("user", JSON.stringify(userData));
        if (token) localStorage.setItem("token", token);
      }

      showToast(resBody.message || "Đăng nhập Google thành công! 🎉", "success");

      if (onSuccess) onSuccess(userData);

      setTimeout(() => {
        const roleStr = String(userData.role || "").toUpperCase();
        const roleId = Number(userData.id);
        if (roleStr === "ADMIN" || roleId === 1) {
          navigate("/admin");
        } else {
          navigate("/");
        }
      }, 1000);

    } catch (error) {
      console.error("Lỗi đăng nhập Google:", error);
      const errorMsg = error.response?.data?.message || "Không thể đăng nhập bằng Google lúc này!";
      showToast(errorMsg, "error");
    }
  };
  const [countdown, setCountdown] = useState(120);

  // Khởi chạy bộ đếm ngược tự động mỗi khi bước OTP được kích hoạt
  React.useEffect(() => {
    let timer;
    if (isOtpStep && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isOtpStep, countdown]);

  // Hàm xử lý khi người dùng nhấn nút gửi lại mã
  const handleResendOtp = async() => {
    try {
      // Gọi API gửi lại OTP xuống Backend
      const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/resend-otp", {
        email: email
      });

      if (response.data && response.data.success === false) {
        showToast(response.data.message || "Không thể gửi lại mã OTP!", "error");
        return;
      }

      setCountdown(120); // Reset lại bộ đếm 120 giây
      showToast("Đã gửi lại mã OTP mới vào Gmail của bạn! ✉️", "success");
    } catch (error) {
      console.error("Lỗi gửi lại OTP:", error);
      const errorMsg = error.response?.data?.message || "Không thể kết nối đến máy chủ để gửi lại OTP!";
      showToast(errorMsg, "error");
    }
  };

  if (isOtpStep) {
    return (
      <form onSubmit={handleVerifyOtp} className="space-y-4 py-4 text-center">
        <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-2">
          <ShieldCheck className="w-6 h-6" />
        </div>
        <h3 className="text-base font-bold text-slate-900">Xác Thực Địa Chỉ Gmail</h3>
        <p className="text-xs text-slate-500 max-w-xs mx-auto">
          Chúng tôi đã gửi mã xác thực 6 chữ số đến hộp thư <span className="font-bold text-slate-800">{email}</span>. Vui lòng kiểm tra và nhập bên dưới.
        </p>

        <div>
          <input
            type="text"
            maxLength="6"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            placeholder="123456"
            className="w-48 text-center tracking-widest font-extrabold text-lg px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-600 transition"
          />
        </div>

        {/* THÊM HIỂN THỊ THỜI GIAN ĐẾM NGƯỢC */}
        <div className="text-xs font-semibold text-amber-600 bg-amber-50 py-1.5 px-3 rounded-lg inline-block my-1">
          {countdown > 0 ? `Mã OTP sẽ hết hạn sau: ${countdown} giây` : "⚠️ Mã OTP đã hết hạn!"}
        </div>

        <button
          type="submit"
          disabled={verifying}
          className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl shadow-lg shadow-indigo-600/30 transition text-xs"
        >
          {verifying ? "Đang xác thực..." : "Xác Nhận OTP"}
        </button>

        {/* ĐÃ SỬA: Chỉ cho phép click nút gửi lại khi thời gian đếm ngược kết thúc bằng 0 */}
        <p className="text-[11px] text-slate-400">
          Không nhận được mã?{" "}
          <button
            type="button"
            disabled={countdown > 0}
            onClick={handleResendOtp}
            className={`font-semibold underline ${countdown > 0 ? "text-slate-300 cursor-not-allowed" : "text-indigo-600 hover:text-indigo-500"}`}
          >
            Gửi lại
          </button>
        </p>
      </form>
    );
  }
  return (
    <form onSubmit={handleLogin} className="space-y-4">
      {/* Ô nhập Email */}
      <div>
        <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Email</label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 w-5 h-5 text-slate-400" />
          <input
            type="email"
            value={email}
            onChange={handleEmail}
            placeholder="name@example.com"
            className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600 transition"
          />
        </div>
        {errEmail && <p className="text-xs text-rose-500 mt-1">{errEmail}</p>}
      </div>

      {/* Ô nhập Mật khẩu */}
      <div>
        <label className="block text-xs font-bold text-slate-700 uppercase mb-1">Mật khẩu</label>
        <div className="relative">
          <Lock className="absolute left-3 top-3 w-5 h-5 text-slate-400" />
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePassword}
            placeholder="••••••••"
            className="w-full pl-10 pr-12 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600 transition"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-slate-400 hover:text-slate-600"
          >
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        {errPassword && <p className="text-xs text-rose-500 mt-1">{errPassword}</p>}
      </div>

      {/* Nút Submit */}
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl shadow-lg shadow-indigo-600/30 transition flex items-center justify-center space-x-2"
      >
        {loading ? (
          <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        ) : (
          <span>Đăng Nhập</span>
        )}
      </button>
      <div className="flex justify-center pt-2">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={() => {
            showToast("Đăng nhập bằng Google thất bại!", "error");
          }}
          useOneTap
        />
      </div>
    </form>
  );
}